'use client';

import React from 'react';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import styles from './TopNavBar.module.scss';

const BackButton: React.FC = () => {
  const router = useRouter();

  return (
    <button className={styles.backButton} onClick={() => router.back()}>
      <Image src="/Vector.svg" alt="Back" width={24} height={24} />
      <span className={styles.backButtonText}>Back</span>
    </button>
  );
};

export default BackButton;
